import React from "react";
//import logo from "../../img/logo-02.png";
import { useRef, useContext, useEffect, useState } from "react";
//import auth from "../../firebase";
//import { Link } from "react-router-dom";
import { MyContext} from "../../context";
import { useNavigate } from 'react-router-dom'
//import supabase from "../../Supa";
//import ClientNavDropMenu from "./ClientNavDropMenu"
import TicketDropMenu from "./TicketDropMenu"
import Uploading from "./Upload"


function TicketNav() {
  //let navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false);

  const OpenImageModal = () => {
    setIsModalOpen(true);
  }

  const closeModal = () => {
    setIsModalOpen(false);
  };


  const { updateUsersEmail, updateUserName, userName, Profile_url} = useContext(MyContext);
  

  useEffect(() => {

    
        
    /*  const Emaildata =  window.localStorage.getItem("UserEmail");
      const Namedata =  window.localStorage.getItem("UserName").replace(/"/g, '');
      
      if(Emaildata !== null && Namedata !== null && userName === "User"){
        updateUsersEmail(Emaildata);
        updateUserName(Namedata);
        }*/
      /*if(Emaildata !== null && Namedata !== null && userName === "User"){
      updateUsersEmail(JSON.parse(Emaildata));
      updateUserName(JSON.parse(Namedata));
      }*/
    
  }, []);

  
  const dropdownRef = useRef();




  return (
    <>
      <div className="topbar">
        <nav className="navbar navbar-light topbarWrapper">
          <div className="topLeft">
            <span>
              
            </span>
          </div>
          <div className="topRight">
            <p className="NavName">{userName}</p>
            <div  onClick={OpenImageModal}>
            <img
              src={Profile_url}
              width={"35px"}
              height={"35px"}
              alt="Profile_image"
              className="topAvatar"
            />
            </div>
           {/* "https://images.pexels.com/photos/3786525/pexels-photo-3786525.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"<div className="topbarIconsContainer homeIcon">
            <Link to="/home" className="IconLink">
                     <span className="material-symbols-rounded ">home</span>
                  </Link>
             
            </div>*/}

            <div className="dropdown" ref={dropdownRef}>
             
                <div
                  className="nav-link topbarIconsContainer IconLink"
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="material-symbols-rounded">notifications</span>
                  <span className="topIconBag">4 </span>
                </div>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <div className="dropdown-item" >
                    notifications
                  </div>
                </div>
              </div>

            <div className="topbarIconsContainer divider">

              <div className="dropdown" ref={dropdownRef}>
             
                <div
                  className="nav-link "
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="material-symbols-rounded">menu</span>
                </div>

                <TicketDropMenu />

              </div>

            </div>
          </div>

        </nav>
      </div>

            {/*Modal*/}
{isModalOpen && (
        <div className="modal fade show" style={{ display: 'block' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
              <span class="material-symbols-rounded">image</span> 
                <button type="button" className="close" onClick={closeModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                { <Uploading />}
              </div>
           
            </div>
          </div>
        </div>
      )}

      {isModalOpen && <div className="modal-backdrop fade show"></div>}
{/*End Modal*/}
    </>
  );
}

export default TicketNav;
